import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CaseStudy from '../components/CaseStudy';
import FlyingRobots from '../components/FlyingRobots';
import useScrollReveal from '../hooks/useScrollReveal';
import { ArrowRight } from 'lucide-react';

export default function CaseStudyPage() {
  useScrollReveal([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#050506] text-white relative min-h-screen">
      <FlyingRobots />
      <Navbar />

      {/* Header hero */}
      <section className="relative pt-[140px] pb-16 border-b border-white/5 overflow-hidden">
        <div className="halftone" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'radial-gradient(600px circle at 30% 30%, rgba(16,185,129,0.14), transparent 60%)',
          }}
        />
        <div className="relative mx-auto max-w-[1400px] px-6">
          <p className="eyebrow mb-3">Case study</p>
          <div className="flex flex-wrap items-center gap-3 mb-6">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="13" r="9" fill="#10b981" />
              <path d="M12 4 Q10 6 12 8 Q14 6 12 4Z" fill="#22c55e" />
            </svg>
            <span className="h-sans text-white text-[24px]">Total Buah Segar</span>
            <span className="pill">
              <span className="dot-live" />PILOT LIVE
            </span>
          </div>
          <h1 className="h-display text-[46px] md:text-[64px] leading-[1.02] max-w-[900px]">
            Fresh produce, forecast to shelf, across{' '}
            <span className="text-[#10b981]">6 branches</span>.
          </h1>
        </div>
      </section>

      <CaseStudy />

      {/* Dashboard CTA */}
      <section className="relative py-16 overflow-hidden border-t border-white/5">
        <div className="mx-auto max-w-[1400px] px-6 text-center">
          <p className="eyebrow text-white/50 mb-3">LIVE DASHBOARD</p>
          <h2 className="h-display text-[36px] md:text-[48px] leading-[1.1] mb-4">
            See Total Buah Segar in action
          </h2>
          <p className="text-white/60 text-[16px] mb-8 max-w-[600px] mx-auto">
            The live procurement dashboard—exceptions, suppliers, branch performance, and real-time metrics.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/tbs-dashboard" className="btn-primary inline-flex items-center gap-2">
              View Dashboard <ArrowRight size={16} />
            </Link>
            <Link
              to="/tbs-dashboard/warehouse-ordering"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white text-[14px] transition-colors border border-white/15 rounded-full px-5 py-2.5"
            >
              See warehouse ordering <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
